
import dayjs from "dayjs";
import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import LoaderSpinner from "~/components/LoaderSpinner.vue";
import ShipSteps from "~/components/ship/ShipSteps.vue";
import Event from "~/entities/Event";

export default Vue.extend({
  components: { ShipSteps, LoaderSpinner },
  layout: "WithServices",
  async asyncData({ params, store, app, error }) {
    store.commit("eventShipping/setEventName", params.event);
    let eventData = await store
      .dispatch("eventShipping/getPartnerId")
      .then((res) => {
        if (res) {
          return res[0].value;
        } else {
          error({
            statusCode: 404,
            message: `Invalid route`,
          });
          return false;
        }
      });
    return {
      eventData: eventData,
    };
  },
  head() {
    return {
      title: (this as any).eventData?.name
        ? (this as any).eventData.name +
          " - " +
          (this as any).eventData.city +
          ", " +
          (this as any).eventData.state +
          " - Bikeflights.com"
        : "Bikeflights.com",
      meta: [
        {
          hid: "partnersdetails",
          name: "partnersdetails",
          content:
            "Ship your bike, wheels and gear with confidence to " +
            (this as any).eventData.name +
            " for " +
            (this as any).eventData.state +
            ". Get costs and ship today!.",
        },
      ],
    };
  },

  data() {
    return {
      isLoading: true as boolean,
      selectedEvent: {} as Event,
      parsedBB: undefined as any,
      flushCaller: "partners-event",
    };
  },
  computed: {
    ...mapGetters({
      activeNotices: "errorsBag/activeNotices" as any,
      alertResponses: "errorsBag/alertResponses" as any,
      loading: "loading",
      stepNumber: "ship/stepNumber",
      stepName: "ship/stepName",
      events: "eventShipping/events",
      currentEvent: "eventShipping/currentEvent",
      eventId: "eventShipping/eventId",
    }),
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
      setBoxes: "ship/setBoxes",
      setTrips: "ship/setTrips",
      setUnits: "ship/setUnits",
      setPurpose: "ship/setPurpose",
      setShipMode: "ship/setShipMode",
      setDetails: "ship/setDetails",
      setStepName: "ship/setStepName",
      setStepNumber: "ship/setStepNumber",
      setInputOptions: "ship/setInputOptions",
      setCurrentEvent: "eventShipping/setCurrentEvent",
      setEventId: "eventShipping/setEventId",
      setEventName: "eventShipping/setEventName",
      flushShipStore: "ship/flush",
      flushPaymentStore: "payment/flush",
    }),
    ...mapActions({
      getEvents: "eventShipping/getEvents",
      getCurrentEvent: "eventShipping/getCurrentEvent",
      searchPartners: "eventShipping/searchPartners",
      clearActiveNotices: "errorsBag/clearActiveNotices",
    }),
    parseDateJs(date: string) {
      return dayjs(new Date(date)).format("MMM/DD/YYYY");
    },
    changeStep(step) {
      if (step === "Search") {
        this.setStepNumber(1);
        this.setStepName("Search");
      } else if (step === "Costs") {
        this.setStepNumber(2);
        this.setStepName("Cost");
      } else if (step === "Details") {
        this.setStepNumber(3);
        this.setStepName("Details");
      } else if (step === "Contents") {
        this.setStepNumber(4);
        this.setStepName("Contents");
      } else if (step === "Payment") {
        this.setStepNumber(5);
        this.setStepName("Payment");
      }
    },
    goStep(stepName, valid) {
      if (valid) {
        this.changeStep(stepName);
      }
    },
    formatAddresses(event: Event) {
      if (event.shipLocations && event.shipLocations.length) {
        this.setInputOptions(event.shipLocations);
      } else {
        this.setInputOptions([]);
      }
    },
    formatURLs(text: string) {
      if (!text) {
        return text;
      }
      let regex = /\[url\s+href=(.*?)\s+target=(.*?)\](.*?)\[\/url\]/g;
      let replacedText = text.replace(regex, '<a href="$1" target="$2">$3</a>');
      return replacedText;
    },
    formatToHtml(text: string) {
      if (!text) {
        return text;
      }
      // Replace [b] and [/b] with <b> and </b>, respectively
      text = text.replace(/\[b\]/g, "<b>");
      text = text.replace(/\[\/b\]/g, "</b>");

      // Replace [i] and [/i] with <i> and </i>, respectively
      text = text.replace(/\[i\]/g, "<i>");
      text = text.replace(/\[\/i\]/g, "</i>");

      // Replace [ul] and [/ul] with <ul> and </ul>, respectively
      text = text.replace(/\[ul\]/g, "<ul>");
      text = text.replace(/\[\/ul\]/g, "</ul>");

      // Replace [li] with <li> and add closing </li> tags
      text = text.replace(/\[li\]/g, "<li>");
      text = text.replace(/\[\/li\]/g, "</li>");

      text = text.replace(/\n\s*\n/g, "<br>");
      return "<p>" + text + "</p>";
    },
    getYear(year: string) {
      let formatYear: Date = new Date(year);
      return formatYear.getFullYear();
    },
  },
  mounted() {
    this.setTrips([]);
    this.setEventName(this.$route.params.event);
    if (this.eventId !== undefined) {
      this.getCurrentEvent();
    } else {
      setTimeout(() => {
        this.searchPartners();
      }, 500);
    }
    this.setStepNumber(1);
  },
  watch: {
    currentEvent() {
      this.selectedEvent = this.currentEvent;
      this.formatAddresses(this.selectedEvent);

      if (this.selectedEvent.typeKey != 11) {
        this.$router.push("/404");
      } else {
        this.isLoading = false;
      }
    },
  },
  beforeDestroy() {
    this.setCurrentEvent({});
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // access to component public instance via `vm`
      if (vm) {
        if (from && from.name == "bicycleshops") {
          (vm as any).flushCaller = "bicycleshops";
        } else {
          if (from && from.name !== "partners-event") {
            (vm as any).clearActiveNotices();
          }
          (vm as any).flushCaller = "partners-event";
        }
        (vm as any).flushShipStore((vm as any).flushCaller); // call payment flusher too
        (vm as any).flushPaymentStore((vm as any).flushCaller);
      }
    });
  },
});
